import { useState } from "react";
import { defaultRenderOnImageError } from "./ScratchNote";
import styles from "./ScratchNote.module.css";
import { CoreSpinner } from "@verity/components/core";
import i18n from "../../../../../i18n";
import { SignatureType } from "@verity/database/prisma";

type SignatureTabPanelProps = {
	imageURL: string | undefined;
	signatureType: SignatureType | null;
};

export default function SignatureTabPanel({ imageURL, signatureType }: SignatureTabPanelProps) {
	const [isLoading, setIsLoading] = useState(true);
	const [hasError, setHasError] = useState(false);
	const renderCurrentImage = () => {
		if (hasError || !imageURL) {
			return defaultRenderOnImageError(
				i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.signature.errorTitle"),
				i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.signature.errorDescription"),
			);
		}

		return (
			<img
				src={imageURL}
				alt={
					signatureType === "drawn"
						? i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.signature.imageAltDrawn")
						: i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.signature.imageAltPhoto")
				}
				onLoad={() => setIsLoading(false)}
				onError={() => {
					setIsLoading(false);
					setHasError(true);
				}}
				className={`${styles.image} ${isLoading ? styles.hidden : styles.visible}`}
			/>
		);
	};

	return (
		<div
			className={`${styles.container} ${signatureType === "drawn" && !hasError && imageURL ? styles.signatureContainer : ""}`}
		>
			<div className={styles.imageContainer}>
				{isLoading && imageURL && <CoreSpinner size={100} />}
				{renderCurrentImage()}
			</div>
		</div>
	);
}
